import { render, staticRenderFns } from "./Chiguayante.vue?vue&type=template&id=7b58ff74&"
import script from "./Chiguayante.vue?vue&type=script&lang=js&"
export * from "./Chiguayante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports